import http from '@/services/http'

export default {
  namespaced: true,
  state: {
    history: [],
    /**
     * Данные для создания finalEncashment
     */
    finalEncashmentData: null,
    finalEncashment: null
  },
  mutations: {
    SET_HISTORY(state, history) {
      state.history = history
    },
    ADD_HISTORY_ITEM(state, item) {
      state.history.push(item)
    },
    REMOVE_HISTORY_ITEM(state, itemIndex) {
      state.history.splice(itemIndex, 1);
    },
    /**
     * выполнится в модуле users в экшене fixateShift
     */
    SET_FINAL_ENCASHMENT_DATA(state, finalEncashmentData) {
      state.finalEncashmentData = finalEncashmentData
    },
    SET_FINAL_ENCASHMENT(state, finalEncashment) {
      state.finalEncashment = finalEncashment
    }
  },
  actions: {
    async getEncashmentHistory({ commit, rootState }) {
      const manufactureId = rootState.manufactures.selectedManufacture.id
      const res = await http.get(`manufacture/${manufactureId}/encashment`)
      commit('SET_HISTORY', res)
    },
    async createEncashment({ commit, rootState }, amount) {
      const manufactureId = rootState.manufactures.selectedManufacture.id
      commit('pageLoader/SET_LOADING', true, { root: true })
      try {
        const res = await http.post(`manufacture/${manufactureId}/encashment`, { amount })
        commit('ADD_HISTORY_ITEM', res)
        const cashbox = rootState.orders.cashbox
        if (cashbox) {
          commit('orders/SET_ORDERS_CASHBOX', {
            ...cashbox,
            cash_in_stock: cashbox.cash_in_stock - amount
          }, { root: true })
        }
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true })
      }
    },
    async cancelLastEncashment({ commit, rootState, state }, encashment_id) {
        commit('pageLoader/SET_LOADING', true, { root: true })
        try {
          if (encashment_id) {
            await http.delete(`encashment/${encashment_id}`)
          } else {
            const lastEncashment = state.history[state.history.length - 1]
            if (lastEncashment) {
              await http.delete(`encashment/${lastEncashment.encashment_id}`)
              commit('REMOVE_HISTORY_ITEM', state.history.length - 1)
              const cashbox = rootState.orders.cashbox
              if (cashbox) {
                commit('orders/SET_ORDERS_CASHBOX', {
                  ...cashbox,
                  cash_in_stock: cashbox.cash_in_stock + lastEncashment.amount
                }, { root: true })
              }
            }
          }
        } finally {
          commit('pageLoader/SET_LOADING', false, { root: true })
        }
    },
    async createFinalEncashment({state, commit }, amount) {
      if (state.finalEncashmentData) {
        const { admin_shift_id } = state.finalEncashmentData
        try {
          commit('pageLoader/SET_LOADING', true, { root: true })
          const res = await http.post(`admin_shift/${admin_shift_id}/encashment`, { amount })
          commit('SET_FINAL_ENCASHMENT', res)
        } finally {
          commit('pageLoader/SET_LOADING', false, { root: true })
        }
      }
    },
    async updateEncashment({ commit }, { encashment_id, amount }) {
      try {
        commit('pageLoader/SET_LOADING', true, { root: true })
        return await http.patch(`encashment/${encashment_id}`, {
          amount
        })
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true })
      }
    }
  }
}